import { Camera, Mic, SwitchCamera } from "lucide-react";

const Pick = ({ Icon, value, onChange, items, testId, label }) => (
  <label className="flex items-center gap-2 min-w-0 flex-1 rounded-xl border border-border bg-background px-2.5 py-1.5 text-xs">
    <Icon className="h-3.5 w-3.5 text-primary shrink-0" />
    <select value={value} onChange={(e) => onChange(e.target.value)} aria-label={label} className="flex-1 min-w-0 bg-transparent outline-none truncate" data-testid={testId}>
      {items.map((d, i) => <option key={d.deviceId || i} value={d.deviceId}>{d.label || `${label} ${i + 1}`}</option>)}
    </select>
  </label>
);

export const DevicePicker = ({ devices, video, cam, mic, onCam, onMic, onFlip }) => {
  const cams = devices.filter((d) => d.kind === "videoinput");
  const mics = devices.filter((d) => d.kind === "audioinput");
  if (mics.length < 2 && (!video || cams.length < 2)) return null;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="record-device-picker">
      {video && cams.length > 1 && (
        <>
          <Pick Icon={Camera} value={cam} onChange={onCam} items={cams} testId="record-camera-select" label="Camera" />
          <button type="button" onClick={onFlip} className="inline-flex items-center gap-1.5 rounded-xl border border-border px-2.5 py-1.5 text-xs hover:border-primary/50" data-testid="record-camera-flip" title="Switch to the other camera">
            <SwitchCamera className="h-3.5 w-3.5 text-primary" /> Flip
          </button>
        </>
      )}
      {mics.length > 1 && <Pick Icon={Mic} value={mic} onChange={onMic} items={mics} testId="record-mic-select" label="Microphone" />}
    </div>
  );
};
